import { useTranslation } from 'react-i18next';
import { useInviteUserMutation } from '../shared/useInviteUserMutation';
import Text from '../../../../shared/Text';

export const InviteUser = ({ name, userId }) => {
  const { t } = useTranslation('users');
  const { mutate } = useInviteUserMutation();

  return (
    <>
      <Text variant="body3">
        {t('inviteSentModal.successInvite', { name })}
      </Text>
      <Text
        color="primary.100"
        variant="button"
        as="a"
        pt="10px"
        onClick={() => mutate(userId)}
      >
        {t('inviteSentModal.sendInvite')}
      </Text>
    </>
  );
};
